var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDestinationIconA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2618",
    "data-name": "Group 2618",
    transform: "translate(-377.012 -1076.388)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1884",
    "data-name": "Rectangle 1884",
    width: 17,
    height: 17,
    rx: 8.5,
    transform: "translate(377.012 1076.388)",
    fill: "#3bb2d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M2.766,0,1.7-2.725H-1.734L-2.789,0H-3.8L-.41-8.6H.428L3.8,0ZM1.389-3.621l-1-2.654q-.193-.5-.4-1.236A11.1,11.1,0,0,1-.375-6.275L-1.383-3.621Z",
    transform: "translate(385.512 1089.371)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationIconA);
export default __webpack_public_path__ + "static/media/destination_icon_a.b69c14bbb0696388c2a3cbd719002f0d.svg";
export { ForwardRef as ReactComponent };